import { GameModeName, GameTotals } from '../../shared/replayStats';
import { getUserSettings, saveUserSettings } from './userSettings';

/** User stats must not count anything that can identify a player */

export function getGameTotals() {
    return getUserSettings().gameTotals ?? {};
}

export function recordGameStarted(mode: GameModeName) {
    updateGameTotals(mode, totals => totals.played++);
    try {
        const settings = getUserSettings();
        const today = getUtcDay();
        const count = settings.gamesToday?.day === today ? settings.gamesToday.count : 0;
        settings.gamesToday = { day: today, count: count + 1 };
        saveUserSettings(settings);
    }
    catch (error) {
        console.error('Could not count the game played today', error); //Only stats
    }
}

export function getPlayedToday() {
    const gamesToday = getUserSettings().gamesToday;
    return gamesToday?.day === getUtcDay() ? gamesToday.count : 0;
}

function getUtcDay() {
    return new Date().toISOString().slice(0, 10);
}

export function recordGameResult(mode: GameModeName, hasWon: boolean) {
    updateGameTotals(mode, totals => hasWon ? totals.wins++ : totals.losses++);
}

function updateGameTotals(mode: GameModeName, update: (totals: GameTotals) => void) {
    try {
        const settings = getUserSettings();
        settings.gameTotals = settings.gameTotals ?? {};
        const totals = settings.gameTotals[mode] ?? { played: 0, wins: 0, losses: 0 };
        update(totals);
        settings.gameTotals[mode] = totals;
        saveUserSettings(settings);
    }
    catch (error) {
        console.error('Could not update game totals', error); //Only stats, never worth stopping a game over
    }
}
